module.exports = __webpack_public_path__ + "img/linkedin_gray.94ab5c85.svg";